import styled from "styled-components"

import {Para} from "@irati/ui/src/Labels"
import {LatoLight} from "@irati/ui/src/global/fonts"


export default styled(Para)`
  ${({medium}) => medium && LatoLight}
  ${({large}) => large && "font-size: 18px;"}
`
